export default __webpack_public_path__ + "static/baskerville-2c61324d29c495432c7aa62decd773a8.woff";